import { pipe, prop } from 'ramda';

// eslint-disable-next-line import/prefer-default-export
export const getAcceptCookie = pipe(prop('acceptCookie'), Boolean);



// WEBPACK FOOTER //
// ./src/app/acceptCookies/selectors.js